import { render, staticRenderFns } from "./UsuarioBuscaTabela.vue?vue&type=template&id=2047f2b9"
import script from "./UsuarioBuscaTabela.vue?vue&type=script&lang=js"
export * from "./UsuarioBuscaTabela.vue?vue&type=script&lang=js"
import style0 from "./UsuarioBuscaTabela.vue?vue&type=style&index=0&id=2047f2b9&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports